module.exports = __webpack_public_path__ + "static/media/tutorial.7bda2623.svg";